module.exports = {
  IMAGE_LIST_DEFAULT_WIDTH: 265,
  IMAGE_RESPONSE_DEFAULT_WIDTH: 245,
}
